<template>
  <div ref="table" class="qweb-table" :class="uniqueClass" v-resize="onResize" @mouseenter="onMouseenter" @mouseleave="onMouseleave" @wheel="scrollByWheel">
    <div class="header">
      <slot name="left-header"></slot>
      <slot name="right-header"></slot>
    </div>
    <div class="body" :class="{'column-scrollbar': false}" :style="bodyStyleObject">
      <slot name="empty" v-if="count===0"></slot>
      <scrollbar ref="scrollbar" class="rows" :fill="fill">
        <div ref="content" class="content">
          <slot name="rows" v-for="(item,index) in displayData" :data="item" :index="index"></slot>
        </div>
        <div class="fill">
          <div class="link-row" :class="[((displayLastIndex + fillIndex) % 2 === 0) ? 'even' : 'odd']" v-for="(fillItem, fillIndex) in fillData" :key="fillIndex">
            <div class="data-row left" v-if="leftFills">
              <div class="data" v-for="index in leftFills" :key="index"></div>
            </div>
            <div class="data-row right">
              <div class="data" v-for="index in rightFills" :key="index"></div>
            </div>
          </div>
        </div>
      </scrollbar>
    </div>
    <column-scrollbar ref="columnScrollbar" :table="$refs.table" :data="data" v-on:columnScrollbarShow="onColumnScrollbarShow"></column-scrollbar>
    <div class="qweb-page" v-if="usePage || useServerPage">
      <div class="left">
        <div class="q-icon-button first" @click="first" :class="{ disabled: firstDisabled }" :title="$t('page.first')">
          <span class="icon-first" :path="'page'"></span>
        </div>
        <div class="q-icon-button previous" @click="previous" :class="{ disabled: previousDisabled }" :title="$t('page.pageUp')">
          <span class="icon-pre" :path="'page'"></span>
        </div>
        <div class="line"></div>
        <div class="title">{{$t('page.page')}}</div>
        <input class="page-now" type="text" v-model="pageNow" :disabled="pageNowDisabled" @change="calculate" @keyup.enter="calculate"/>
        <div class="page-total">/{{pageTotal}}</div>
        <div class="line"></div>
        <div class="q-icon-button next" @click="next" :class="{ disabled: nextDisabled }" :title="$t('page.pageDown')">
          <span class="icon-next" :path="'page'"></span>
        </div>
        <div class="q-icon-button last" @click="last" :class="{ disabled: lastDisabled }" :title="$t('page.last')">
          <span class="icon-last" :path="'page'"></span>
        </div>
        <div class="q-icon-button refresh" @click="refresh" :title="$t('page.refresh')">
          <span class="icon-refresh" :path="'page'"></span>
        </div>
      </div>
      <div class="right">
        <!-- <div class="line"></div> -->
        <div class="display-title">{{$t('page.displayItem', displayStart, displayEnd, total)}} </div>
        <div class="line"></div>
        <div class="show-title">{{$t('page.show')}}</div>
        <div ref="show" class="show-number" @click="openShow">
          <div class="page-count">{{pageCount}}</div>
          <div class="q-icon-button down" :class="{ active: showOptions}">
            <span class="icon-triangle-down" :path="'page'"></span>
          </div>
          <!-- <button class="q-icon-button down" :class="{ active: showOptions}" /> -->
          <div ref="showMenu" class="show-options" v-show="showOptions">
            <div class="show-option" v-for="option in show" @click="onShowOptionClick(option.value)" :key="option.value">{{option.text}}</div>
          </div>
        </div>
        <div class="items-title">{{$t('page.items')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { uniqueId, get, endsWith } from 'lodash'
import resize from 'vue-resize-directive'
import Scrollbar from '../Scrollbar'
import columnScrollbar from './ColumnScrollbar'
const rowHeight = 28
const pageShow = [{
  text: '5',
  value: 5
}, {
  text: '10',
  value: 10
}, {
  text: '25',
  value: 25
}, {
  text: '50',
  value: 50
}]
export default {
  name: 'fixed-table',
  components: {
    Scrollbar,
    columnScrollbar
  },
  directives: {
    resize
  },
  props: {
    usePage: {
      type: Boolean,
      default: false
    },
    useServerPage: {
      type: Boolean,
      default: false
    },
    paginateAction: {
      type: Function,
      default () {}
    },
    dataKey: {
      type: String
    },
    leftFills: 0,
    rightFills: 0,
    data: Array,
    selectAllDefault: {
      type: Boolean,
      default: false
    },
    sort: {
      type: String
    },
    sortOrder: {
      type: String,
      default: 'asc'
    },
    headerHeight: {
      type: Number
    },
    showCount: {
      type: Number
    }
  },
  data () {
    return {
      top: 0,
      pageTotal: 0,
      pageNow: 0,
      pageCount: 0,
      show: pageShow,
      displayStart: 0,
      displayEnd: 0,
      displayData: [],
      fillData: [],
      total: 0,
      fill: false,
      filters: [],
      serverFilters: [],
      filterMap: new Map(),
      serverFilterMap: new Map(),
      showOptions: false,
      bodyStyleObject: {
        height: 'calc(100% - 40px)',
        maxHeight: 'calc(100% - 40px)'
      },
      selectAllInitialled: false,
      selectAll: false,
      selectedItems: [],
      mouseInsideTable: false,
      leftColumnWidthMap: new Map(),
      rightColumnWidthMap: new Map(),
      uniqueClass: ''
    }
  },
  computed: {
    pageComponentHeight: function () {
      if (this.usePage || this.useServerPage) {
        return 25
      } else {
        return 0
      }
    },
    pageNowDisabled: function () {
      return (this.pageTotal <= 1)
    },
    firstDisabled: function () {
      return (this.total === 0 || this.pageNow === 1)
    },
    previousDisabled: function () {
      return (this.total === 0 || this.pageNow === 1)
    },
    nextDisabled: function () {
      return (this.total === 0 || this.pageNow === this.pageTotal)
    },
    lastDisabled: function () {
      return (this.total === 0 || this.pageNow === this.pageTotal)
    },
    displayLastIndex: function () {
      return this.displayData.length - 1
    },
    fillRemainedRow: function () {
      return (this.leftFills > 0 || this.rightFills > 0)
    },
    hasSelectedItems () {
      return this.selectedItems.length > 0
    },
    count () {
      if (this.data) {
        return this.data.length
      } else {
        return 0
      }
    }
  },
  created: function () {
    this.pageCount = this.showCount || this.show[0].value
    this.pageNow = 1
    window.addEventListener('click', this.onWindowClick)
  },
  mounted: function () {
    this.initialCloumns()
    this.updateBodyHeight()
    if (this.data && this.data.length > 0) {
      this.calculate()
    }
    window.addEventListener('keydown', this.onKeydown)
    this.uniqueClass = uniqueId('table_')
    this.createColumnStyle()
  },
  destroyed: function () {
    window.removeEventListener('click', this.onWindowClick)
    window.removeEventListener('keydown', this.onKeydown)
    this.removeColumnSytle()
  },
  methods: {
    onMouseenter (event) {
      this.mouseInsideTable = true
    },
    onMouseleave (event) {
      this.mouseInsideTable = false
    },
    onKeydown (event) {
      if (this.mouseInsideTable) {
        switch (event.keyCode) {
          case 38:
            this.$refs.scrollbar.up()
            break
          case 40:
            this.$refs.scrollbar.down()
            break
          // case 37:
          //   this.$refs.columnScrollbar.onLeftClick()
          //   break
          // case 39:
          //   this.$refs.columnScrollbar.onRightClick()
          //   break
        }
      }
    },
    initialCloumns () {
      this.lastSortCompare = undefined
      this.columns = []
      this.$children.forEach((child) => {
        let componentTag = child.$options._componentTag
        if (componentTag === 'column') {
          this.columns.push(child)
        } else if (endsWith(componentTag, 'column')) {
          if (componentTag !== 'checkbox-column') {
            this.columns.push(child.$children[0])
          }
        }
      })
      if (this.sort) {
        this.columns.forEach((column) => {
          if (this.sort === column.sort) {
            column.sortColumn(this.sortOrder)
          }
        })
      }
    },
    sortColumn (columnIndex, order) {},
    createColumnStyle () {
      this.style = document.createElement('style')
      document.head.appendChild(this.style) // must append before you can access sheet property
      let sheet = this.style.sheet
      for (let [index, value] of this.leftColumnWidthMap) {
        try {
          sheet.insertRule(`.${this.uniqueClass}>.header>.left-header>.qweb-column:nth-child(${index + 1}) { width: ${value};}`)
          sheet.insertRule(`.${this.uniqueClass}>.body .link-row>.left>.data:nth-child(${index + 1}) { width: ${value};}`)
        } catch (error) {
          sheet.addRule(`.${this.uniqueClass}>.header>.left-header>.qweb-column:nth-child(${index + 1})`, `width: ${value}`)
          sheet.addRule(`.${this.uniqueClass}>.body .link-row>.left>.data:nth-child(${index + 1})`, `width: ${value}`)
        }
      }
      for (let [index, value] of this.rightColumnWidthMap) {
        try {
          sheet.insertRule(`.${this.uniqueClass}>.header>.right-header>.qweb-column:nth-child(${index + 1}) { width: ${value};}`)
          sheet.insertRule(`.${this.uniqueClass}>.body .link-row>.right>.data:nth-child(${index + 1}) { width: ${value};}`)
        } catch (error) {
          sheet.addRule(`.${this.uniqueClass}>.header>.right-header>.qweb-column:nth-child(${index + 1})`, `width: ${value}`)
          sheet.addRule(`.${this.uniqueClass}>.body .link-row>.right>.data:nth-child(${index + 1})`, `width: ${value}`)
        }
      }
    },
    removeColumnSytle () {
      if (this.style) {
        document.head.removeChild(this.style)
      }
    },
    selectAllItems () {
      this.selectAll = true
      this.updateSelectedItems()
    },
    unSelectAllItems () {
      this.selectAll = false
      this.updateSelectedItems()
    },
    toggleSelectAll () {
      this.selectAll = !this.selectAll
      this.updateSelectedItems()
    },
    updateSelectedItems () {
      if (this.selectAll) {
        let temp = []
        this.displayData.forEach((item) => {
          if (item.hasOwnProperty('checkable')) {
            if (item.checkable) {
              temp.push(get(item, this.dataKey))
            }
          } else {
            temp.push(get(item, this.dataKey))
          }
        })
        this.selectedItems = temp
      } else {
        this.selectedItems = []
      }
      this.selectedItemsChanged()
    },
    getLeftColumnWidthMap () {
      return this.leftColumnWidthMap
    },
    getRightColumnWidthMap () {
      return this.rightColumnWidthMap
    },
    getSelectedData () {
      return this.displayData.filter((data) => {
        return (this.selectedItems.indexOf(get(data, this.dataKey)) !== -1)
      })
    },
    selectedItemsChanged () {
      this.$emit('selectedItemsChanged')
    },
    onColumnScrollbarShow (show) {
      this.useColumnScrollbar = show
      this.updateBodyHeight()
    },
    updateBodyHeight () {
      let headerHeight = parseInt(this.headerHeight || 40)
      let otherHeight = headerHeight
      if (this.usePage || this.useServerPage) {
        otherHeight += 39
      }
      if (this.$refs.columnScrollbar.show) {
        otherHeight += 12
      }
      this.bodyStyleObject.height = 'calc(100% - ' + otherHeight + 'px)'
      this.bodyStyleObject.maxHeight = 'calc(100% - ' + otherHeight + 'px)'
    },
    onResize () {
      this.calculate()
    },
    scrollTo: function (element) {
      this.$refs.scrollbar.scrollTo(element)
    },
    scrollByWheel: function (event) {
      this.$el.scrollLeft = (event.deltaX > 0) ? this.$el.scrollLeft + 10 : this.$el.scrollLeft - 10
      event.preventDefault()
    },
    onWindowClick: function (event) {
      if (!this.usePage && !this.useServerPage) return
      let showMenu = this.$refs.showMenu
      let show = this.$refs.show
      if (event.target !== showMenu && event.target !== show && !showMenu.contains(event.target) && this.showOptions && !show.contains(event.target)) {
        this.showOptions = false
      }
    },
    applyFilter: function (key, filter, serverFilter) {
      this.filterMap.set(key, filter)
      this.serverFilterMap.set(key, serverFilter)
      let newFilters = []
      let newServerFilters = []
      for (let value of this.filterMap.values()) {
        newFilters.push(value)
      }
      for (let value of this.serverFilterMap.values()) {
        newServerFilters.push(value)
      }
      this.filters = newFilters
      this.serverFilters = newServerFilters
      if (this.useServerPage) {
        this.serverPaginate()
      } else {
        this.calculate()
      }
    },
    openShow: function (event) {
      if (event.target.className === 'show-option') return
      this.showOptions = true
    },
    refresh: function () {
      this.$emit('refresh', this.top)
    },
    async serverPaginate () {
      let filter = {}
      for (let [key, value] of this.serverFilterMap) {
        filter[key] = value
      }
      let result = await this.paginateAction(this.pageNow, this.pageCount, filter)
      this.pageNow = result.page
      this.pageTotal = result.pages
      this.total = result.total
      this.displayStart = ((this.pageNow - 1) * this.pageCount) + 1
      this.displayEnd = (this.displayStart + this.pageCount) - 1
      if (this.displayEnd > this.total) {
        this.displayEnd = this.total
      }
    },
    first: function () {
      if (this.firstDisabled) return
      this.pageNow = 1
      if (this.useServerPage) {
        this.serverPaginate()
      } else {
        this.calculate()
      }
    },
    previous: function () {
      this.$log.info('>>>> previous')
      if (this.previousDisabled) return
      if (this.pageNow > 1) {
        this.pageNow--
        if (this.useServerPage) {
          this.serverPaginate()
        } else {
          this.calculate()
        }
      }
    },
    next: function () {
      this.$log.info('>>>> next')
      if (this.nextDisabled) return
      if (this.pageNow < this.pageTotal) {
        this.pageNow++
        if (this.useServerPage) {
          this.serverPaginate()
        } else {
          this.calculate()
        }
      }
    },
    last: function () {
      if (this.lastDisabled) return
      this.pageNow = this.pageTotal
      if (this.useServerPage) {
        this.serverPaginate()
      } else {
        this.calculate()
      }
    },
    onShowOptionClick: function (value) {
      this.pageCount = value
      this.pageNow = 1
      this.showOptions = false
      if (this.useServerPage) {
        this.serverPaginate()
      } else {
        this.calculate()
      }
    },
    calculate: function () {
      const canUseHeight = this.$refs.table.offsetHeight - rowHeight
      if (canUseHeight === 0) return
      let filterData = this.data.concat([])
      if (typeof this.lastSortCompare !== typeof undefined) {
        filterData.sort(this.lastSortCompare)
      }
      // filter data
      if (!this.useServerPage) {
        if (this.filters) {
          this.filters.forEach(filter => {
            filterData = filterData.filter(filter)
          })
        }
      }
      this.total = filterData.length
      // page data
      if (this.usePage) {
        this.pageTotal = Math.ceil(this.total / this.pageCount)
        this.displayStart = ((this.pageNow - 1) * this.pageCount) + 1
        this.displayEnd = (this.displayStart + this.pageCount) - 1
        if (this.displayEnd > this.total) {
          this.displayEnd = this.total
        }
        this.displayData = filterData.slice(this.displayStart - 1, this.displayEnd)
      } else {
        this.displayData = filterData
      }
      if (!this.selectAllInitialled && this.selectAllDefault) {
        this.selectAll = true
        this.updateSelectedItems()
      }
      /**
       * get displayData height after rendering
       */
      this.$nextTick(function () {
        const displayHeight = this.$refs.content.offsetHeight
        const remainderHeight = canUseHeight - displayHeight
        this.fillData = []
        if (remainderHeight > 0 && this.fillRemainedRow && this.displayData.length > 0) {
          const remainderCount = Math.ceil(remainderHeight / rowHeight)
          for (let i = 0; i < remainderCount; i++) {
            this.fillData.push({})
          }
        }
        this.fill = (this.fillData.length > 0)
        this.$refs.columnScrollbar.calculate()
      })
    }
  },
  watch: {
    data: function (value) {
      if (value) {
        this.calculate()
      }
    }
  }
}
</script>
<style lang="scss">
@import '../../assets/scss/variables.scss';
.data-row-background {
  &.even {
    background-color: #FFF;
  }
  &.odd {
    // background-color: #FFF;
  }
}

$link-row-height:38px;
.qweb-table {
  height: 100%;
  overflow: hidden; // disable default scrollbar
  // position: relative; //for scroll bar
  >.header {
    // position: relative; //for scroll bar
    // z-index: 2; //for scroll bar
    display: flex;
    font-size: 0;
    background-color: #E5E5E5;
    >div:first-child {
      border-left: #F2F3F8 1px solid;
    }
    >div:last-child {
      border-right: #F2F3F8 1px solid;
    }
    >.left-header {
      white-space: nowrap;
      z-index: 2;
    }
    >.right-header {
      white-space: nowrap;
      position: relative;
      flex: 1; // overflow-x: hidden; // disable default scrollbar
    }
  }
  >.body {
    position: relative; //for empty absolute
    // z-index: 1; //for scroll bar
    width: 100%; //for scroll bar
    font-size: 0;
    // border-bottom: #e5e5e5 1px solid;
    &:not(.column-scrollbar) {
      .data-row {
        overflow: hidden;
      }
    }
    >.rows {
      width: 100%;
      height: 100%;
      >.scroll-content {
        .link-row {
          position: relative;
          display: flex;
          border-bottom: #e5e5e5 1px solid;
          height: 40px;
          &:hover {
            >.data-row {
              background: #ECF6FC;
            }
          }
          &:active {
            >.data-row {
              background: #ECF6FC;
            }
          }
          >.data-row:first-child {
            >.data:first-child {
              border-left: #e5e5e5 1px solid;
            }
            >.data:last-child {
              border-right: #e5e5e5 1px solid;
            }
          }
          >.data-row {
            display: flex;
            position: relative;
            @extend .data-row-background;
            &.left {
              z-index: 1;
            }
            &.right {
              flex: 1;
            }
            >.data {
              // text-align: center;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              color: #2f2f2f;
              display: inline-block;
              padding-left: 16px;
              padding-right: 10px;
              line-height: $link-row-height;
              overflow: hidden;
            }
          }
        }
        >.fill {
          >.link-row {
            @extend .data-row-background;
            >.data-row {
              height: $link-row-height;
            }
          }
        }
      }
    }
  }
  >.qweb-page {
    background-color: #fff;
    height: 39px;
    line-height: 39px;
    padding-left: 40px;
    padding-right: 40px;
    display: flex;
    font-size: 12px;
    color: #2f2f2f;
    position: relative;
    border: 1px solid #ececec;
    border-top: none;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 1;
    .title {
      font-size: 13px;
      color: #2F2F2F;
      line-height: 39px;
    }
    >.left {
      >div {
        display: inline-block;
      }
      >.title {
        line-height: 39px;
      }
      >.page-now {
        width: 60px;
        height: 30px;
        font-size: 13px;
        color: #000000;
        padding: 0 7px;
        line-height: 30px;
        margin-left: 10px;
        margin-right: 5px;
        text-align: left;
        border: 1px solid #979797;
        border-radius: 4px;
      }
      >.page-total {
        font-size: 13px;
        color: #2F2F2F;
        line-height: 39px;
      }
      >.first, >.next {
        margin-right: 6px;
      }
      >.previous, >.next, >.last, >.refresh, >.first {
        cursor: pointer;
        color: #000000;
        height: 20px;
        &:hover {
          color: #4C4C4C;
          background: none;
        }
        &.disabled {
          color: #AEAEAE;
        }
        &>span {
          vertical-align: middle;
        }
      }
    }
    >.right {
      flex: 1;
      text-align: right;
      font-size: 13px;
      color: #2F2F2F;
      line-height: 39px;
      >div {
        display: inline-block;
      }
      >.show-title {
        margin-right: 4px;
      }
      >.show-number {
        color: #3246c5;
        cursor: pointer;
        position: relative;
        padding-right: 6px;
        line-height: 25px;
        >.page-count {
          display: inline-block;
          text-align: center;
          font-size: 12px;
        }
        >.down {
          display: inline-block;
          vertical-align: middle;
          width: 20px;
          height: 20px;
          color: #4875F5;
          &.active {
            color: #2847A0;
          }
          &:hover {
            color: #89A5F4;
          }
        }
        >.show-options {
          position: absolute;
          bottom: 25px;
          background-color: #fff;
          border: #848484 1px solid;
          >.show-option {
            padding: 0 10px;
            color: #2f2f2f;
            &:hover {
              background-color: #defefd;
            }
          }
        }
      }
    }
    .icon {
      width: 16px;
      height: 15px;
      cursor: pointer;
      vertical-align: middle;
      display: inline-block;
      &.disabled {
        cursor: default;
      }
    }
    .line {
      width: 1px;
      height: 14px;
      background-color: #F1F1F1;
      margin-left: 10px;
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .button {
    margin: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/table/FixedTable.vue